import { useCallback, useEffect, useState } from 'react';
import orderBy from 'lodash.orderby';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { buildService } from '@rd-web-markets/shared/dist/services/service';
const api = buildService('/claim_project_reports/{id}/select_competent_professionals', {
  only: ['all', 'create']
});
const newProjectCompetentProfessionalsService = buildService('/claim_groups/{id}/new_project_competent_professionals', {
  only: ['all']
});
const competentProfessionalSelect = {
  useCompetentProfessionalSelect(show) {
    let forNewProjectCreation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const [data, setData] = useState([]);
    const {
      report_id
    } = useParams();
    const {
      claimGroupId
    } = useParams();
    const getNewProjectClaimGroupCompetentProfessionals = competentProfessionalSelect.useGetNewProjectClaimGroupCompetentProfessionals(claimGroupId, setData);
    const getNonProjectCompetentProfessionals = useErrorHandling(useCallback(async () => {
      if (forNewProjectCreation) {
        getNewProjectClaimGroupCompetentProfessionals();
      } else {
        competentProfessionalSelect.useGetCompetentProfessionals(setData, report_id);
      }
    }, [forNewProjectCreation, getNewProjectClaimGroupCompetentProfessionals, report_id]));
    const selectCompetentProfessional = useErrorHandling(useCallback(async (id, data, setTableData, tableData) => {
      const response = await this.post(report_id, {
        id: id
      });
      const newData = data.filter(d => d.id !== Number(id));
      setData([...newData]);
      setTableData([...tableData, response]);
    }, [report_id]));
    useEffect(() => {
      if (show) {
        getNonProjectCompetentProfessionals();
      }
    }, [getNonProjectCompetentProfessionals, show]);
    return [data, selectCompetentProfessional, setData, report_id];
  },
  async useGetCompetentProfessionals(setData, selectedProjectId) {
    let searchQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    let sortBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'name';
    let sortOrder = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'asc';
    const searchParams = {};
    if (searchQuery) {
      const searchQueryTrimmed = searchQuery.trim();
      if (searchQueryTrimmed.length) searchParams.search = searchQueryTrimmed;
    }
    searchParams.sort_by = sortBy;
    searchParams.sort_order = sortOrder;
    const response = await competentProfessionalSelect.get(selectedProjectId, searchParams);
    setData([...response]);
  },
  useGetNewProjectClaimGroupCompetentProfessionals(claimGroupId, setCompetentProfessionals) {
    const fetchCompetentProfessionals = useErrorHandling(useCallback(async function () {
      let searchQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      const competentProfessionals = await newProjectCompetentProfessionalsService.all(claimGroupId, {
        search: (searchQuery || '').trim()
      });
      setCompetentProfessionals(competentProfessionals);
    }, [claimGroupId, setCompetentProfessionals]));
    return fetchCompetentProfessionals;
  },
  async get(selectedProjectId, searchParams) {
    const allNonProjectCompetentProfessionals = await api.all(selectedProjectId, searchParams);
    return allNonProjectCompetentProfessionals;
  },
  async post(selectedProjectId, body) {
    return await api.create(selectedProjectId, body);
  }
};
export default competentProfessionalSelect;